var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      ref: "documentModalRef",
      staticClass: "document-container",
      attrs: { row: "", wrap: "" }
    },
    [
      _vm._l(_vm.coDocymentTypes, function(btn, index) {
        return _c(
          "v-flex",
          { key: index, attrs: { xs3: "", "text-xs-center": "" } },
          [
            _c(
              "v-btn",
              {
                ref: "btn-" + btn.type + "-" + btn.id,
                refInFor: true,
                staticClass:
                  "primary--text document-container__upload--button  white--background",
                style: _vm.dtButtonStyle,
                on: {
                  click: function($event) {
                    _vm.handleUploadDocument(index, btn)
                  }
                }
              },
              [
                _c(
                  "v-container",
                  { attrs: { "vertical-height": "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", "text-xs-center": "" } },
                          [_c("v-icon", [_vm._v(_vm._s(btn.icon_class))])],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticStyle: {
                              "word-break": "keep-all",
                              "white-space": "normal"
                            },
                            attrs: { xs12: "", "text-xs-center": "" }
                          },
                          [
                            _c(
                              "strong",
                              {
                                staticClass:
                                  "primaryDark--text mt-1 upload__title"
                              },
                              [_vm._v(_vm._s(btn.name))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form",
                  { ref: "form-" + btn.type + "-" + btn.id, refInFor: true },
                  [
                    _c("input", {
                      ref: "input-" + btn.type + "-" + btn.id,
                      refInFor: true,
                      staticClass: "input-file",
                      staticStyle: { display: "none" },
                      attrs: {
                        id: btn.id,
                        type: "file",
                        accept: btn.acceptedType
                      },
                      on: {
                        change: function($event) {
                          _vm.handleAddFile($event.target, btn, index)
                        }
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "upload__file-uploaded", attrs: { xs12: "" } },
        _vm._l(_vm.vModel, function(file, index) {
          return _c(
            "v-list",
            { key: file.id },
            [
              _c("v-divider", {
                staticClass: "upload__file-uploaded--divider"
              }),
              _vm._v(" "),
              _c(
                "v-list-tile",
                { attrs: { avatar: "" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { attrs: { size: "50" } },
                    [_c("v-icon", [_vm._v("icon-add-file")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", {
                        domProps: { innerHTML: _vm._s(file.name) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-icon",
                        {
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              _vm.handleRemoveFile(file)
                            }
                          }
                        },
                        [_vm._v("icon-delete")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d68c06e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d68c06e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-documents/components/block-document-modal/template.html
// module id = null
// module chunks = 